<template>
  <div class="home">
    <div class="info w-md-100 left">
      <h1>Mohamed <span>El-Sayed</span></h1>
      <p>
        Teaching Assistant at the faculty of computer and information - Assiut
        university
      </p>
      <p>
        Full-Stack Developer who design and develope responsive websites.
        <br />My expertise is to Create and design websites
      </p>
      <a
        class="animate__animated animate__backInUp"
        href="https://drive.google.com/file/d/1ikqu4Onu_PgixUyPkx-N5t9MlY_5nsuR/view?usp=sharing"
        target="_blank"
        ><button>Download CV</button></a
      >
    </div>
    <div class="img d-none d-lg-block p-4 right">
      <img
        :src="require('../assets/me3.jpg')"
        alt=""
        style="border-radius: 5px"
      />
    </div>
    <div class="links">
      <a href="https://web.facebook.com/Eldbeany" target="_blank" class="link"
        >Facebook</a
      >
      <a
        href="https://www.linkedin.com/in/imohamedsayed/"
        target="_blank"
        class="link"
        >Linkedin</a
      >
      <a href="https://github.com/imohamedsayed" target="_blank" class="link"
        >GitHub</a
      >
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: "HomeView",
  components: {},
  data() {
    return {};
  },
  mounted() {
    gsap.from(".right", {
      x: 1400,
      opacity: 0,
      duration: 1,
    });
    gsap.from(".left", {
      x: -1400,
      opacity: 0,
      duration: 1,
    });
  },
};
</script>

<style lang="scss">
.home {
  display: flex;
  gap: 70px;
  height: calc(100vh - 112px);
  align-items: center;
  justify-content: space-between;
  .info {
    width: calc(100% / 2);
    @media (max-width: 1175px) {
      width: 100%;
      padding: 20px;
    }

    h1 {
      font-size: 2.5rem;
      color: var(--text-black-900);
      span {
        color: var(--skin-color);
      }
    }
    p {
      font-size: 1.6rem;
      color: var(--text-black-700);
      line-height: 1.5;
    }
    button {
      margin-top: 40px;
      width: 200px;
      height: 50px;
      border-radius: 25px;
      font-size: 20px;
      background: transparent;
      color: var(--active-color);
      border: 1px solid var(--active-color);
      cursor: pointer;
      transition: all 0.5s ease;
      &:hover {
        color: var(--text-black-900);
        background: var(--active-color);
      }
    }
    @media (max-width: 978px) {
      width: 100%;
    }
  }
  .img {
    width: calc(100% / 3);
    position: relative;
    img {
      width: 100%;
      height: 380px;
    }
    &::after {
      content: "";
      position: absolute;
      height: 80px;
      width: 80px;
      border-bottom: 10px solid var(--skin-color);
      border-right: 10px solid var(--skin-color);
      right: 0px;
      bottom: -40px;
    }
    &::before {
      content: "";
      position: absolute;
      height: 80px;
      width: 80px;
      border-top: 10px solid var(--skin-color);
      border-left: 10px solid var(--skin-color);
      left: 0px;
      top: -40px;
    }
    @media (max-width: 1175px) {
      display: none !important;
    }
  }
  .links {
    display: flex;
    flex-direction: column;
    gap: 200px;
    justify-content: flex-end;
    @media (max-width: 768px) {
      display: none;
    }
    a {
      text-decoration: none;
      transform: rotate(90deg);
      color: var(--text-black-700);
      font-size: 1.2rem;
      letter-spacing: 3px;
      margin: 0;
      transition: all 0.3s ease;
      &:hover {
        color: var(--skin-color);
      }
    }
  }
}
</style>
